import {StatusCreateReq, StatusDetailRes, StatusUpdatePosReq} from "./status.contract";
import {TransitionCreateReq, TransitionDetailRes} from "./transition.contract";
import {Type} from 'class-transformer';
import {TrackerType} from '../../../enums';
import {TrackerWorkflowRes} from './tracker/tracker.contract';


export class WorkflowDetailRes {
    id!: number;
    name!: string;

    @Type(() => StatusDetailRes)
    states!: StatusDetailRes[];

    @Type(() => TransitionDetailRes)
    transitions: TransitionDetailRes[] = [];

    type!: TrackerType

    @Type(() => TrackerWorkflowRes)
    trackers: TrackerWorkflowRes[] = []

    constructor(n?: string, s?: StatusDetailRes[], c?: TransitionDetailRes[]) {
        if (s !== undefined && n !== undefined && c !== undefined) {
            this.states = s;
            this.name = n;
            this.transitions = c;
        }
    }
}

export class WorkflowCreateReq {
    name!: string
    forType!: TrackerType
    states?: StatusCreateReq[]
    transitions?: TransitionCreateReq[]
}

export class WorkflowUpdatePosReq {
    id!: number
    states: StatusUpdatePosReq[] = []
}